
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/auth.service';
import { ConfigService } from '../services/getSettings';

@Injectable({
    providedIn: 'root'
})

export class ApiService {
    protected appSettings = ConfigService.settings;
    
    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private router: Router
    ) {
    }

    private apiUrl: string = this.appSettings.apiSettings.apiUrl;

    async post(endPoint: string, jsonContent: string) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': "*",
            'Authorization': `Bearer ${sessionStorage.getItem("tokenInfo")}`
        });

        return await this.http.post(`${this.apiUrl}${endPoint}`, jsonContent, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }
    async getExtToken(endPoint: string, token: string) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': "*",
            'Authorization': `Bearer ${token}`
        });

        return await this.http.get(`${this.apiUrl}${endPoint}`, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async postFormData(endPoint: string, formData: FormData) {

        var header = new HttpHeaders({
            //'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': this.appSettings.apiSettings.apiOrigin,
            'Authorization': `Bearer ${sessionStorage.getItem("tokenInfo")}`
        });

        return await this.http.post(`${this.apiUrl}${endPoint}`, formData, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async postExtToken(endPoint: string, jsonContent: string, token: string) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': "*",
            'Authorization': `Bearer ${token}`
        });

        return await this.http.post(`${this.apiUrl}${endPoint}`, jsonContent, { headers: header }).toPromise();
    }

    
    async postAnonymous(endPoint: string, jsonContent: string) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': "*"
        });

        return await this.http.post(`${this.apiUrl}${endPoint}`, jsonContent, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async put(endPoint: string, jsonContent: string) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this.appSettings.apiSettings.apiOrigin,
            'Authorization': `Bearer ${sessionStorage.getItem("tokenInfo")}`
        });

        return await this.http.put(`${this.apiUrl}${endPoint}`, jsonContent, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async putFormData(endPoint: string, formData: FormData) {

        var header = new HttpHeaders({
            //'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this.appSettings.apiSettings.apiOrigin,
            'Authorization': `Bearer ${sessionStorage.getItem("tokenInfo")}`
        });

        return await this.http.put(`${this.apiUrl}${endPoint}`, formData, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async get(endPoint: string, parameters?: HttpParams) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this.appSettings.apiSettings.apiOrigin,
            'Authorization': `Bearer ${sessionStorage.getItem("tokenInfo")}`
        });

        return await this.http.get(`${this.apiUrl}${endPoint}`, { params: parameters, headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async getAnonymous(endPoint: string, parameters?: HttpParams) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this.appSettings.apiSettings.apiOrigin,
        });

        return await this.http.get(`${this.apiUrl}${endPoint}`, { params: parameters, headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }

    async delete(endPoint: string, id: string) {

        var header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': this.appSettings.apiSettings.apiOrigin,
            'Authorization': `Bearer ${sessionStorage.getItem("tokenInfo")}`
        });
        return await this.http.delete(`${this.apiUrl}${endPoint}/${id}`, { headers: header }).toPromise().then((data) => {
            return data;
        }).catch(error => {
            throw this.handleResponse(error);
        });
    }
    private handleResponse(err) {
        if (err.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(['/account/login']);
        }
        if (err.status === 403) {
            this.router.navigate(['/pages/403']);
        }

        return err;
    }
}